import { Spacing12 } from 'autogen/design-tokens/tokens';
import HighlightedText from 'components/generic/HighlightedText';
import React from 'react';
import styled from 'styled-components';

export interface ISubscriptionUSP {
    usp: string;
}

const StyledHighlightedText = styled(HighlightedText)`
    padding-top: ${Spacing12};
    padding-right: ${Spacing12};
`;

export default function SubscriptionUSP(props: ISubscriptionUSP) {
    const { usp } = props;

    if (!usp) {
        return null;
    }

    return (
        <StyledHighlightedText color="ColorSubscription1" withBorder={false}>
            {usp}
        </StyledHighlightedText>
    );
}
